exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topic-block {\n  display: flex;\n  height: 100%; }\n  .topic-block:hover {\n    background-color: #fcfcfc;\n    cursor: pointer; }\n  .topic-block svg {\n    color: #008cba;\n    font-size: 1.5rem; }\n  .topic-block .topic-description {\n    color: #888; }\n  .topic-block .icon-container {\n    padding-right: 20px;\n    padding-top: 10px; }\n", ""]);

// exports
